<template>
  <div class="home bg-grey">
    <NavbarMain />
    <div class="row m-0 pt-5">
      <div class="col-md-auto d-none d-md-block">
        <MenuCategory :categories="categories" :kind="'Products'" />
      </div>
      <div class="col">
        <div class="container">
          <div class="row">
            <FakeProduct
              v-for="fp in fakeProducts"
              :key="fp"
              class="col-xl-3 col-md-6 pt-4"
            />
            <Product
              v-for="product in products"
              :key="product._id"
              class="col-xl-3 col-md-6 pt-4"
              :product="product"
              :kind="'products'"
            />
            <div class="col">
              <div
                v-bind:class="
                  products.length == 0 && fakeProducts.length == 0
                    ? ''
                    : 'd-none'
                "
              >
                <h3>Ups! no se encontraron productos</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavbarMain from "@/components/NavbarMain.vue";
import MenuCategory from "@/components/MenuCategory.vue";
import Product from "@/components/Product";
import Api from "../tools/Api2";
import Configs from "../configs/configs";
import FakeProduct from "@/components/FakeProduct.vue";
import { mapState } from "vuex";

export default {
  name: "Search",
  data() {
    return {
      categorySelected: "",
      products: [],
      categories: [],
      fakeProducts: [1, 2, 3, 4],
      url: Configs.API.BASE,
    };
  },
  components: {
    NavbarMain,
    Product,
    MenuCategory,
    FakeProduct,
  },
  methods: {
    selectCategory(id) {
      if (id) {
        this.categorySelected = id;
        return Api(
          `product?filter[category]=${id}&filter[state]=1&filter[sellerPlaces]=${this.flag}`
        )
          .get()
          .then((res) => {
            this.products = res.products;
          });
      }

      Api(`product?filter[state]=1&filter[sellerPlaces]=${this.flag}`)
        .get()
        .then((res) => {
          this.products = res.products;
        });
    },
  },
  computed: {
    ...mapState(["flag"]),
  },
  mounted: async function () {
    Api("category?filter[kind]=producto")
      .get()
      .then((res) => {
        this.categories = res.categories;
      });

    const name = this.$route.params.title;
    Api(
      `product?search[${this.$route.query.seller ? 'seller' : 'name'}]=${name}&filter[state]=1&filter[sellerPlaces]=${this.flag}`
    )
      .get()
      .then((res) => {
        this.fakeProducts = [];
        this.products = res.products;
      });
  },
};
</script>